
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'SectionHeader',
})
export default class extends Vue {
  @Prop()
  title: string

  @Prop()
  caption: string
}
